import { messages as utilMessages } from '@sdir/utilities/lib/localization';

/* eslint-disable max-len */
const messages = {
  nb: {
    ...utilMessages.no,
    'language': 'Norsk',
    'name': 'Navn',
    'birthnumber': 'Fødselsdato',
    'status': 'Status',
    'expirydate': 'Gyldig til dato',
    'userbar.menu': 'Meny',
    'status.valid': 'Gyldig',
    'status.expired': 'Utgått',
    'certificate.number': 'Sertifikatnummer',
    'certificate.notfound': 'Sertifikat ikke funnet',
    'sid.title': 'Sjøfartskort',
    'sid.issueddate': 'Utstedt dato',
    'sid.valid': 'Gyldig',
    'sid.invalid': 'Ugyldig',
    'sid.search.header': 'Søk etter Sjøfartskort',
    'sid.notfound': 'Sjøfartskort ikke funnet',
    'sid.number': 'Dokumentnummer',
    'dispensation.search.header': 'Søk etter dispensasjon',
    'dispensation.number': 'Dispensasjonsnummer',
    'dispensation.notfound': 'Dispensasjon ikke funnet',
    'dispensation.notvalid': 'Dispensasjon ikke gyldig',
    'health.number': 'Helseerklæringnummer',
    'health.search.header': 'Søk etter helseerklæring',
    'health.notfound': 'Helseerklæring ikke funnet',
    'health.decisiondate': 'Vedtaksdato',
    'health.examinationdate': 'Dato for undersøkelse',
    'health.practitioner': 'Underskrivende lege',
    'endorsement.number': 'Påtegningsnummer',
    'endorsement.search.header': 'Søk etter påtegning',
    'endorsement.notfound': 'Påtegning ikke funnet',
    'endorsement.minrequirements':
      'This certificate is issued in accordance with the International Convention on Standards of Training, Certification, and Watchkeeping for Seafarers, 1978, as amended.',
    'endorsement.limitation': 'In accordance with national certification',
    'required.field': 'Obligatorisk felt',
    'search': 'Søk',
    'certificate.search.header': 'Søk etter sertifikat',
    'certificate.overview.header.valid': 'Sertifikat er gyldig',
    'certificate.overview.header.invalid': 'Sertifikat er ikke gyldig',
    'certificate.status.Valid': 'Sertifikat er gyldig',
    'certificate.status.Cancelled': 'Sertifikat er kansellert',
    'certificate.status.Expired': 'Sertifikat er utgått',
    'certificate.status.Inactive': 'Sertifikat er inaktivt',
    'certificate.overview.number': 'Sertifikatnummer',
    'certificate.overview.cert.name': 'Sertifikat',
    'certificate.overview.type': 'Sertifikattype',
    'certificate.overview.name': 'Navn',
    'certificate.overview.validfrom.date': 'Gyldig fra',
    'certificate.overview.issued.date': 'Utstedt dato',
    'certificate.overview.expiry.date': 'Utløpsdato',
    'certificate.overview.code': 'Sertifikatkode',
    'header.language.english': 'Engelsk',
    'header.language.norwegian': 'Norsk',
    'home.page.title': 'Verification Service',
    'userbar.sdirlink': 'Gå til Sjøfartsdirektoratet (sdir.no)',
    'userbar.skiplink': 'Hopp til hovedinnhold',
    'footer.tagline': '- Den foretrukne maritime administrasjonen',
    'footer.about.title': 'Om sdir.no',
    'footer.about.privacy': 'Personvernerklæring',
    'footer.about.accessibility': 'Tilgjengelighetserklæring',
    'footer.social.title': 'Følg oss',
    'footer.social.facebook': 'Besøk oss på Facebook',
    'footer.social.linkedin': 'Besøk oss på LinkedIn',
    'footer.social.instagram': 'Besøk oss på Instagram',
  },
  en: {
    ...utilMessages.en,
    'language': 'English',
    'name': 'Name',
    'birthnumber': 'Date of birth',
    'status': 'Status',
    'expirydate': 'Expiry date',
    'userbar.menu': 'Menu',
    'status.valid': 'Valid',
    'status.expired': 'Expired',
    'certificate.number': ' Certificate number',
    'certificate.notfound': 'Certificate not found',
    'sid.title': 'Seafarer´s identity card',
    'sid.issueddate': 'Issued date',
    'sid.valid': 'Valid',
    'sid.invalid': 'Invalid',
    'sid.search.header': 'Search for seafarer´s identity card',
    'sid.notfound': 'Seafarer´s identity card not found',
    'sid.number': 'Document number',
    'dispensation.search.header': 'Search for exemption',
    'dispensation.number': 'Exemption number',
    'dispensation.notfound': 'Exemption not found',
    'dispensation.notvalid': 'Exemption not valid',
    'health.number': 'Declaration number',
    'health.search.header': 'Search for health declaration',
    'health.notfound': 'Health declaration not found',
    'health.decisiondate': 'Decision date',
    'health.examinationdate': 'Examination date',
    'health.practitioner': 'Seafarer´s Doctor',
    'endorsement.number': 'Endorsement number',
    'endorsement.search.header': 'Search for endorsement',
    'endorsement.notfound': 'Endorsement not found',
    'endorsement.minrequirements':
      'This certificate is issued in accordance with the International Convention on Standards of Training, Certification, and Watchkeeping for Seafarers, 1978, as amended.',
    'endorsement.limitation': 'In accordance with national certification',
    'required.field': 'Required field',
    'search': 'Search',
    'certificate.search.header': 'Search for certificate',
    'certificate.overview.header.valid': 'Certificate is valid',
    'certificate.overview.header.invalid': 'Certificate is not valid',
    'certificate.status.Valid': 'Certificate is valid',
    'certificate.status.Cancelled': 'Certificate is cancelled',
    'certificate.status.Expired': 'Certificate is expired',
    'certificate.status.Inactive': 'Certificate is inactive',
    'certificate.overview.number': 'Certificate number',
    'certificate.overview.cert.name': 'Certificate name',
    'certificate.overview.type': 'Certificate type',
    'certificate.overview.name': 'Name',
    'certificate.overview.validfrom.date': 'Valid from',
    'certificate.overview.issued.date': 'Issued date',
    'certificate.overview.expiry.date': 'Expiry date',
    'certificate.overview.code': 'Certificate code',
    'header.language.english': 'English',
    'header.language.norwegian': 'Norwegian',
    'home.page.title': 'Verification Service',
    'userbar.sdirlink': 'Go to Sjøfartsdirektoratet (sdir.no)',
    'userbar.skiplink': 'Skip to main content',
    'footer.tagline': '- The preferred maritime administration',
    'footer.about.title': 'About sdir.no',
    'footer.about.privacy': 'Privacy Policy',
    'footer.about.accessibility': 'Accessibility statement',
    'footer.social.title': 'Follow us',
    'footer.social.facebook': 'Visit us on Facebook',
    'footer.social.instagram': 'Visit us on Instagram',
    'footer.social.linkedin': 'Visit us on LinkedIn',
  },
};

export default messages;
